<template>
    <div class="content">
        <el-button type="primary" class="el-icon-plus" style="background-color: #2FBC82;" @click="AddClick"> 新增</el-button>
        <div style="margin-top:15px;width:100%">
             <el-row v-for="(page, index) of pages" :key="index" :gutter="20" style="margin:10px">
                <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="item of page" :key="item.dis_id">
                    <el-card style="height:175px;margin-bottom: 10px;">
                        <div style="position:relative;">
                            <div class="label" :style="{background:(item.dr_type===0?'#FFA500':(item.dr_type===1?'#008000':(item.dr_type===2?'red':'#507BCA'))),color:'white'}">
                                <div v-if="item.dr_type==0">时长券</div>
                                <div v-if="item.dr_type==1">金额券</div>
                                <div v-if="item.dr_type==2">折扣券</div>
                                <div v-if="item.dr_type==3">全免券</div>
                            </div>
                        </div>
                        <el-row>
                        <el-col :span="24">
                            <div class="line" style="width:50%">
                            <span style="float:left;font-size:23px;margin-left: 5px;">{{item.dr_name}}</span>
                            </div>
                        </el-col>
                        </el-row>
                        <el-row  style="margin-top:10px" >
                            <div class="line" style="width:100%;margin-left: 5px;">
                                <el-col :span="15">
                                    <div style="font-size:13px;float:left;text-align:left;">
                                      <div v-html="FormateTitle(item)"></div>
                                    </div>
                                    </el-col>
                                    <el-col :span="9">
                                    <div style="font-size:28px;text-align:left;float:left">
                                        <span v-if="item.dr_type===0">{{item.dr_value}}分钟</span>
                                        <span v-if="item.dr_type===1">{{item.dr_value/100}} 元</span>
                                        <span v-if="item.dr_type===2">{{item.dr_value/100}} 折</span>
                                        <span v-if="item.dr_type===3">全免</span>
                                    </div>
                                </el-col>
                            </div>
                        </el-row>
                        <el-row style="margin-top:20px">
                            <el-col :span="24" style="margin-left: 5px;">
                              <div class="p">
                                 <div>
                                    <span style="font-size:13px">售价：</span>
                                    <span style="font-size:20px;color:red">{{item.dr_price}}元</span>
                                </div>
                                <div style="margin-right: 10px;">
                                    <el-button-group>
                                        <el-button icon="el-icon-edit" @click="Edit(item)"></el-button>
                                        <el-button icon="el-icon-delete" @click="Del(item)"></el-button>
                                    </el-button-group>
                                </div>
                              </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
             </el-row>
        </div>

        <!--弹框-->
        <el-dialog :title="title" :visible.sync="dialogVisible" :width='screenWidth<738?"70%":(screenWidth<1200?"50%":"35%")' :append-to-body='true' top="2vh">
            <el-form :model="disForm" :rules="rules" ref="disForm" label-width="150px" size='medium'>
                <el-form-item label="优惠券名" prop="dr_name">
                    <el-input v-model="disForm.dr_name"></el-input>
                </el-form-item>
                <el-form-item label="优惠券类型">
                    <el-select v-model="disForm.dr_type"   :disabled='disForm.dr_id>0?true:false' style="width:100%;">
                        <el-option label="时长减免" :value='0'></el-option>
                        <el-option label="金额减免" :value='1'></el-option>
                        <el-option label="折扣减免" :value='2'></el-option>
                        <el-option label="全免" :value='3'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="disForm.dr_type===0?'单张额度(分钟)':(disForm.dr_type===1?'单张额度(元)':(disForm.dr_type===2?'单张额度(折)':'单张额度'))"  prop="dr_value">
                    <el-input-number v-model="disForm.dr_value" :disabled="disForm.dr_type===3?true:false" controls-position="right" :precision="disForm.dr_type===0?0:2" :min="0" style="width:100%"></el-input-number>
                </el-form-item>
                <el-form-item label="售价">
                    <el-input-number v-model="disForm.dr_price" controls-position="right" :precision="2" :min="0" style="width:100%"></el-input-number>
                </el-form-item>
               
                <el-form-item v-if='disForm.dr_type===3' label="全免次数">
                  <el-radio-group v-model="radio_num">
                    <el-radio :label="0">不限制</el-radio>
                    <el-radio :label="1">限制</el-radio>
                  </el-radio-group>
                  <div v-if="radio_num===1" class="a">
                    <el-input-number  v-model="disForm.dr_limit_num" controls-position="right" :min="1" :max=255 style="width:200px"></el-input-number>
                    <span>&nbsp;次</span>
                  </div>
                </el-form-item>
                <el-form-item v-if='disForm.dr_type!==3' label="不同类型优惠券叠加">
                  <el-radio-group v-model="disForm.dr_repeat_add">
                    <el-radio :label="0">不限制</el-radio>
                    <el-radio :label="1">限制</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="派发时段限制">
                    <el-radio-group v-model="radio_time">
                      <el-radio :label="0">不限制</el-radio>
                      <el-radio :label="1">限制</el-radio>
                    </el-radio-group>
                    <div v-if="radio_time===1" class="a">
                      <el-time-picker  is-range v-model="disForm.time" format="HH:mm:ss" value-format="HH:mm:ss" range-separator="-" placeholder="选择时间范围" style="width: 200px;"></el-time-picker>
                    </div>
                </el-form-item>
                <el-form-item label="折扣有效期">
                  <div class="a" style="margin-top: 0px;">
                    <el-input-number v-model="disForm.dr_time_value" controls-position="right" :precision="0" :min="1" style="width:150px"></el-input-number>
                    <span>&nbsp;分钟</span>
                  </div>
                </el-form-item>
                <el-form-item label="商户当日派发限制">
                  <el-radio-group v-model="mc_limit">
                    <el-radio :label="0">不限制</el-radio>
                    <el-radio :label="1">限制</el-radio>
                  </el-radio-group>
                  <div v-if="mc_limit===1" class="a">
                    <el-input-number  v-model="disForm.dr_mc_limit_num" controls-position="right" :min="1" style="width:200px"></el-input-number>
                    <span>&nbsp;张</span>
                  </div>
                </el-form-item>
                <el-form-item label="日同车牌派发次数">
                  <el-radio-group v-model="plate_count">
                    <el-radio :label="0">不限制</el-radio>
                    <el-radio :label="1">限制</el-radio>
                  </el-radio-group>
                  <div v-if="plate_count===1" class="a">
                    <el-input-number  v-model="disForm.dr_plate_limit_count" controls-position="right" :min="1" style="width:200px"></el-input-number>
                    <span>&nbsp;次</span>
                  </div>
                </el-form-item>
                <el-form-item label="单日同车牌派发张数">
                  <el-radio-group v-model="plate_num">
                    <el-radio :label="0">不限制</el-radio>
                    <el-radio :label="1">限制</el-radio>
                  </el-radio-group>
                  <div v-if="plate_num===1" class="a">
                    <el-input-number  v-model="disForm.dr_plate_limit_num" controls-position="right" :min="1" style="width:200px"></el-input-number>
                    <span>&nbsp;张</span>
                  </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import util from '../../util/util'

export default {
  data: function () {
    return {
      screenWidth: 0,
      DisRulesListData: [],
      dialogVisible: false,
      title: '',

      radio_num:0,//全免
      radio_time:0,
      mc_limit:0,
      plate_count:0,
      plate_num:0,

      disForm: {
        dr_id: 0,
        dr_name: '',
        dr_type: 0,
        dr_value: 0,
        dr_price: 0.00,
        dr_time_value:1440,
        dr_limit_num:0,
        dr_mc_limit_num:1,
        dr_plate_limit_count:1,
        dr_plate_limit_num:1,
        dr_repeat_add:0,
        time:[]
      },
      rules: {
        dr_name: [{ required: true, message: '请输入优惠券名', trigger: 'blur' }],
        dr_value: [{ required: true, message: '请输入优惠券额度', trigger: 'blur' }],
        dr_price: [{ required: true, message: '请输入优惠券价格', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.screenWidth = document.body.clientWidth
    this.GetDisRulesData()
  },
  computed: {
    pages () {
      const pages = []
      this.DisRulesListData.forEach((item, index) => {
        const page = Math.floor(index / 4)// 4条为一行
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })
      return pages
    },
    FormateTitle(){
      return function(row){
          let title='<span>'
          let t1='优惠券<span style="color:red">'+(row.dr_repeat_add===0?"不限制":"限制")+'</span>叠加，<span style="color:red">'+(row.dr_limit_time_begin?"限制":"不限")+'</span>派发时段'
          title+=t1
          if(row.dr_mc_limit_num>0){
            title+='，'
            title+='<br/>'
             let t2='<span>'+(row.dr_mc_limit_num===0?"":"商户当日派发")+'</span><span style="color:red">'+(row.dr_mc_limit_num===0?"":"限制"+row.dr_mc_limit_num+"张")+'</span>'
            title+=t2
          }
          if(row.dr_plate_limit_count>0){
            title+='，'
            title+='<br/>'
             let t2='<span>'+(row.dr_plate_limit_count===0?"":"同车牌当日派发")+'</span><span style="color:red">'+(row.dr_plate_limit_count===0?"":"限制"+row.dr_plate_limit_count+"次")+'</span>'
            title+=t2
          }
          if(row.dr_plate_limit_num>0){
            title+='，'
            title+='<br/>'
            let t2='<span>'+(row.dr_plate_limit_num===0?"":"同车牌当日派发")+'</span><span style="color:red">'+(row.dr_plate_limit_num===0?"":"限制"+row.dr_plate_limit_num+"张")+'</span>'
            title+=t2
          }
          if(row.dr_type===3){
            title+='，'
            title+='<br/>'
            let t2='<span>有效期内<span style="color:red">'+(row.dr_limit_num===0?'不限使用次数':('限使用'+row.dr_limit_num+'次'))+'</span></span>'
            title+=t2
          }
          title+='</span>'
          return title
        }
    }
  },
  methods: {
    GetDisRulesData () {
      util.Get('disrules/getdisrulesdatalist').then(res => {
        if (res.rpStatus === 10000) {
          this.DisRulesListData = res.list
        }
      })
    },
    AddClick () {
      if(util.CheckUserAuth('3-1-1')){
        this.dialogVisible = true
        this.title = '新增'
        this.disForm.dr_id = 0
        this.disForm.dr_name = ''
        this.disForm.dr_type = 0
        this.disForm.dr_value = 0
        this.disForm.dr_price = 0.00
        this.disForm.dr_limit_num=1
        this.radio_num=1
        this.disForm.dr_time_value=1440
        this.mc_limit=0,
        this.disForm.dr_mc_limit_num=1,
        this.plate_count=0,
        this.disForm.dr_plate_limit_count=1,
        this.plate_num=0,
        this.disForm.dr_plate_limit_num=1
        this.disForm.dr_repeat_add=0
        this.disForm.time=['00:00:00',"23:59:59"]
      }
    },
    Edit (row) {
      if(util.CheckUserAuth('3-1-2')){
        this.disForm = JSON.parse(JSON.stringify(row))
        if (row.dr_type === 1 || row.dr_type === 2) {
          this.disForm.dr_value = row.dr_value / 100
        }

        if(this.disForm.dr_type===3){
          this.radio_num=(this.disForm.dr_limit_num===0?0:1)
        }


        this.radio_time=0
        if(this.disForm.dr_limit_time_begin && this.disForm.dr_limit_time_end){
          this.radio_time=1
          this.$set(this.disForm,'time',[this.disForm.dr_limit_time_begin,this.disForm.dr_limit_time_end])
        }

        this.mc_limit=this.disForm.dr_mc_limit_num>0?1:0
        this.plate_count=this.disForm.dr_plate_limit_count>0?1:0
        this.plate_num=this.disForm.dr_plate_limit_num>0?1:0
        this.dialogVisible = true
        this.title = '修改'
      }
    },
    Del (row) {
      if(util.CheckUserAuth('3-1-3')){
        this.$confirm('确定删除优惠券“' + row.dr_name + '”？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.Get('disrules/del?id=' + row.dr_id+'&name='+row.dr_name).then(res => {
            if (res.rpStatus === 10000) { this.GetDisRulesData() } else { this.$message.error(util.ErrorMsg(res.rpStatus)) }
          })
        }).catch(e => e)
      }
    },
    submit () {
      this.$refs.disForm.validate((valid) => {
        if (valid) {
          if (this.disForm.dr_type === 1 || this.disForm.dr_type === 2) { this.disForm.dr_value = this.disForm.dr_value * 100 }
          
          if(this.radio_time===1&&(!this.disForm.time||this.disForm.time.length===0)){
            this.$message.error('派发时段禁止为空')
            return
          }
          this.disForm.dr_limit_time_begin=''
          this.disForm.dr_limit_time_end=''
          if(this.radio_time===1&&this.disForm.time){
            this.disForm.dr_limit_time_begin=this.disForm.time[0]
            this.disForm.dr_limit_time_end=this.disForm.time[1]
          }

          if(this.radio_num===0){
            this.disForm.dr_limit_num=0
          }


          this.disForm.dr_mc_limit_num=(this.mc_limit===0?0:this.disForm.dr_mc_limit_num)
          this.disForm.dr_plate_limit_count=(this.plate_count===0?0:this.disForm.dr_plate_limit_count)
          this.disForm.dr_plate_limit_num=(this.plate_num===0?0:this.disForm.dr_plate_limit_num)
          
          util.Post('disrules/edit', this.disForm).then(res => {
            if (res.rpStatus === 10000) {
              this.GetDisRulesData()
              this.dialogVisible = false
            } else { this.$message.error(res.rpStatus) }
          })
          
        }
      })
    }
  }
}
</script>

<style scoped>
.content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.a{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}
.p{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.label{
  font-size:15px;
  color: white;
  line-height:30px;
  position:absolute;
  right: 1rem;;
  top:1rem;
  z-Index:2;
  padding:0 2em;
  -webkit-transform-origin:left bottom;
  -moz-transform-origin:left bottom;
  transform-origin:left bottom;
  -webkit-transform:translate(50%,-160%) rotate(45deg);
  -moz-transform:translate(50%,-160%) rotate(45deg);
  transform:translate(50%,-160%) rotate(45deg);
  text-indent:0;
}
::v-deep .el-dialog{
  --el-bg-color:#000741 !important;
}
::v-deep .el-dialog__header{
  --el-text-color-primary:#1effff;
  --el-text-color-regular:#fff;
  padding: 0px !important;
  background-color: #309CE2;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__title{
    color: white;
}

::v-deep .el-dialog__headerbtn .el-dialog__close{
    color: white;
} 

</style>
